<template>
  <v-container grid-list-xl pa-3 mt-5>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 pt-0>
        <h1 class="display-1 mb-1 text-xs-center">
          Some Sold Properties
        </h1>
        <p class="subheading text-xs-center font-italic grey--text mb-0">
          This information is believed to be accurate, but without warranty.
        </p>
      </v-flex>
      <template v-if="soldPrpglistings.length">
        <prpg-listing-card
          v-for="listing in soldPrpglistings"
          :key="listing.id"
          :listing="listing"
        ></prpg-listing-card>
      </template>
      <div v-else class="flex pt-3 xs12 sm12 lg10 offset-lg1 xl8 offset-xl2">
        <v-alert :value="true" color="info" icon="info" outline>
          Sorry, our listings are currently unavailable
        </v-alert>
      </div>
      <v-alert
        :value="soldPrpglistingsError"
        color="error"
        icon="warning"
        outline
        class="flex mt-3 xs12 sm12 lg10 offset-lg1 xl8 offset-xl2"
      >
        {{ soldPrpglistingsError }}
      </v-alert>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { getSoldListings } from '../api/listings';
import PrpgListingCard from '../components/PrpgListingCard';

export default {
  name: 'Sold',
  metaInfo: {
    title: 'Our Sold Properties',
  },
  components: { PrpgListingCard },
  computed: {
    ...mapGetters({
      soldPrpglistingsError: 'soldPrpglistingsError',
      soldPrpglistings: 'soldPrpglistings',
    }),
  },
  created() {
    this.getSoldListings();
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    getSoldListings() {
      if (window.sessionStorage.getItem('soldprpglistings') === null) {
        this.$store.dispatch('soldPrpglistings');
        getSoldListings()
          .then((res) => {
            this.$store.commit('soldPrpglistingsSuccess', res);
            this.listingsSuccess();
          })
          .catch((error) => {
            this.listingsFailed();
            this.$store.commit('soldPrpglistingsFailed', { error });
          });
      } else {
        JSON.parse(window.sessionStorage.getItem('soldprpglistings'));
      }
    },
    listingsSuccess() {
      this.showSnackbar({
        text: 'Listings loaded successfully!',
        color: 'success',
        timeout: 5000,
      });
    },
    listingsFailed() {
      this.showSnackbar({
        text: 'There were problems getting the Listings!',
        color: 'warning',
        timeout: 5000,
      });
    },
  },
};
</script>
